import PropTypes from 'prop-types';

import { useAppSelector } from '@/redux';

import SummaryCheck from './SummaryCheck';

const CheckCgv = ({ t, acceptCgv, onChange, required = false }) => {
  const age = useAppSelector(({ root }) => root.storeConf.ageLimit);
  const actAsCustomer = useAppSelector(({ admin }) => admin.actAsCustomer);

  return (
    <SummaryCheck
      actAsCustomer={actAsCustomer}
      t={t}
      id="CGV"
      required={required}
      label={t('legalInformations.acceptCgv', { age })}
      checked={acceptCgv}
      onCheckedChange={() => onChange(!acceptCgv)}
    />
  );
};

CheckCgv.propTypes = {
  t: PropTypes.func.isRequired,
  acceptCgv: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default CheckCgv;
